.k9{pointer-events:auto;}